import './assets/index.css'
import Vue from 'vue'
// var a = require('xtooltech')
// console.log("require('xtooltech')", a)
if (window.xtooltech) Vue.use(window.xtooltech.default)

/*导入router*/
import router from './router/index'

/*导入element-ui*/
import './plugins/element'

/*注册自定义组件*/
import './components/index'

// import MainContent from './MainContent.vue'


import store from './store'

// const vueRouterPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
// 	//console.log(this)
// 	if(this.currentRoute.path==location){
// 		//this.replace(location);
// 		this.app.$store.commit('routeReload');
// 	}else{
// 		return vueRouterPush.call(this, location);
// 	}
// }

Vue.config.productionTip = false
new Vue({
	router,
	store,
	render(h) { return h(require('./App.vue').default) },
	computed: {
		langs() {
			return ''
		}
	}
}).$mount('#app')
